import { toDate as t } from "./toDate.js";
function n(e, a) {
  const r = t(e), o = t(a);
  return r.getFullYear() === o.getFullYear();
}
export {
  n as default,
  n as isSameYear
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/isSameYear.js
// module id = 1394
// module chunks = 67